import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';

import { updateTrainingRoutineInfo } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
  defaultDateProps,
} from '~/components/Dialog/styles';
import Loading from '~/components/Loading';

export default function EditTrainingRoutineDialog({
  isOpen,
  setIsOpen,
  trainingRoutine,
  refreshTrainingRoutines,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      await updateTrainingRoutineInfo(trainingRoutine.id, values);
      toast.success('Treino alterado com sucesso !');

      refreshTrainingRoutines();
    } catch (error) {
      toast.error('Ops, não foi possivel alterar este treino!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  const getUpdatableFields = () => {
    const { title, goal, expectedFinishDate, observations } = trainingRoutine;
    return { title, goal, expectedFinishDate, observations };
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>Alterar treino</SDialogTitle>
      <Formik
        enableReinitialize
        initialValues={getUpdatableFields()}
        onSubmit={handleSubmit}
      >
        <Form>
          <div>
            <Field name="title" label="Nome do treino" {...defaultFieldProps} />
            <Field name="goal" label="Objetivo" {...defaultFieldProps} />
            <Field
              type="date"
              name="expectedFinishDate"
              label="Data estimada de finalização"
              {...defaultDateProps}
              {...defaultFieldProps}
            />
            <Field
              name="observations"
              label="Observações"
              multiline
              {...defaultFieldProps}
            />
          </div>

          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Alterar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

EditTrainingRoutineDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  trainingRoutine: PropTypes.object.isRequired,
  refreshTrainingRoutines: PropTypes.func.isRequired,
};
